import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors } from '@/utils/constants';

const darkTheme = {
  root: {
    '& $title': {
      color: TextColors.light,
    },
    '& $superHeading': {
      color: SecondaryColors.main,
    },
  },
};

const lightTheme = {
  root: {
    '& $title': {
      color: TextColors.dark,
    },
    '& $superHeading': {
      color: SecondaryColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
    },
    title: {},
    superHeading: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(2),
      },
    },
    tile: {
      cursor: 'zoom-in',

      '& > *': {
        paddingTop: '100%',
      },

      '& picture': {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        transition: 'transform .5s ease-in-out',
      },

      '&:hover picture': {
        transform: 'scale(1.15)',
      },
    },
    grid: {
      justifyContent: 'center',
    },
    modal: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      width: 'auto',

      [muiTheme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
    },
    modalClose: {
      '&.MuiButtonBase-root': {
        position: 'absolute',
        top: muiTheme.spacing(2),
        right: muiTheme.spacing(2),
        color: TextColors.light,

        [muiTheme.breakpoints.up('md')]: {
          right: 0,
        },
      },
    },
  }),
  { name: 'GenImageGallery' },
);

export default useStyles;
